<template>
<div>
    <el-dialog title="菜单信息"
        :visible="visible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        @close="cancel"
        width="60%">
        <el-form :model="form" ref="form" label-width="120px">
            <el-form-item label="父级菜单">
                <el-select v-model="form.parentId">
                    <el-option :value="0" label="无"></el-option>
                    <el-option v-for="option in menuList"
                        :key="option.id"
                        :value="option.id"
                        :label="option.name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="菜单名称" :rules="rules.requiredItem" prop="name">
                <el-input v-model="form.name" @change="verify"></el-input>
            </el-form-item>
            <el-form-item label="菜单路由">
                <el-input v-model="form.route"></el-input>
            </el-form-item>
            <!-- <el-form-item label="操作管理">
                <div>
                    <el-button type="primary" size="mini" @click="addOperation">新增操作</el-button>
                </div>
                <el-tree
                    :data="funcs"
                    show-checkbox
                    node-key="id"
                    ref="functree"
                    :props="defaultProps">
                </el-tree>


            </el-form-item> -->
            <el-form-item>
                <el-button type="primary" @click="save">保存</el-button>
                <el-button @click="cancel">取消</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>

    <!-- <operation-add v-if="showAddBox"
            :visible="showAddBox"
            @operationAddCallback="operationAddCallback"/> -->
</div>
</template>
<script>
import { Loading } from "element-ui"
// import OperationAdd from './OperationAdd'
export default {
    // components: { OperationAdd },
    props: {
        visible: {
            type: Boolean
        },
        // 传入参数：包含menuId，parent信息等
        menu: {
            type: Object
        },
        // 菜单列表
        menuList: {
            type: Array
        }
    },
    data: vm=>({
        rules: {
            requiredItem: [{required: true, message: '必填项'}]
        },
        form: {
            id: 0,
            name: '',
            route: '',
            parentName: '',
            parentId: 0,
            parentDto: {},
            functionIds: [],
        },
        funcs: [], //操作列表
        showAddBox: false,
        //树结构配置
        defaultProps: {
            children: 'childrenList',
            label: 'alias'
        },
    }),
    mounted(){
        if(this.menu){
            this.findById(this.menu.id)
            if(this.menu.parentId){
                this.form.parentId = this.menu.parentId
            }
        }

        // this.findAllFunc()
    },
    methods: {
        // 添加操作回调，返回操作Id及别名
        operationAddCallback(val){
            if(val){
                this.form.functionIds.push(val.id)
                this.funcs.push(val)
            }
            this.showAddBox = false
        },
        addOperation(){
            this.showAddBox = true
        },
        findAllFunc(){
            this.$axios
                .get(this.baseUrl3 + "function/findAll")
                .then(({ data: { msg, data, code } }) => {
                    if (code == 20000) {
                        this.funcs = data
                    } else {
                        this.$message({ showClose: true, message: msg, type: "error" });
                        console.log(msg);
                    }
                })
                .catch(error => {
                    this.$message({
                        showClose: true,
                        message: "系统异常",
                        type: "error"
                    });
                    console.log(error);
                });
        },
        findById(id){
            if(!id){
                return
            }
            let loading = Loading.service({
                fullscreen: true,
                text: "数据加载中..."
            });
            let url = this.baseUrl3 + "app/findById/" + id
            this.$axios
                .get(url)
                .then(({ data: { msg, data, code } }) => {
                    if (code == 20000) {
                        this.form = data
                        if(data.parentId){
                            this.form.parentId = data.parentId
                        }
                        // if(data.functionList){
                        //     let ids = []
                        //     data.functionList.forEach(fun => {
                        //         if(fun.parentDto){
                        //             ids.push(fun.parentDto.id)
                        //         }
                        //         ids.push(fun.id)
                        //     })
                        //     this.form.functionIds = [...new Set(ids)]
                        //     this.$refs.functree.setCheckedKeys(ids)
                        // }
                    } else {
                        this.$message({ showClose: true, message: msg, type: "error" });
                        console.log(msg);
                    }
                    loading.close();
                })
                .catch(error => {
                    loading.close();
                    this.$message({
                        showClose: true,
                        message: "系统异常",
                        type: "error"
                    });
                    console.log(error);
                });
        },
        verify(name){
            this.$axios
            .get(this.baseUrl3 + 'app/verifyName/' + name)
            .then(({data: {data, code, msg}}) =>{
                if(data){
                    this.$message.warning('名字重复，请重新填写')
                    this.form.name = ''
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        save(){
            let loading = Loading.service({
                fullscreen: true,
                text: "数据加载中..."
            });
            let url = this.baseUrl3 + "app/add"
            if(this.form.id){
                url = this.baseUrl3 + "app/edit"
            }

            // let checkedKeys = this.$refs.functree.getCheckedKeys(true)
            // let halfCheckedKeys = this.$refs.functree.getHalfCheckedKeys()

            let model = {
                id: this.form.id,
                name: this.form.name,
                route: this.form.route,
                parentId: this.form.parentId,
                // functionIds: checkedKeys
            }
            this.$axios.post(url, model)
                .then(({ data: { msg, data, code } }) => {
                    if (code == 20000) {
                        this.cancel(true)
                    } else {
                        this.$message({ showClose: true, message: msg, type: "error" });
                        console.log(msg);
                    }
                    loading.close();
                })
                .catch(error => {
                    loading.close();
                    this.$message({
                        showClose: true,
                        message: "系统异常",
                        type: "error"
                    });
                    console.log(error);
                });
        },
        cancel(flag){
            this.$emit('menuAddCallback', flag ? flag : false)
        },
    },
}
</script>
<style scoped>
.itemWidth{
    width: 50%;
}
</style>
